import Actions from '../action'
const initialState = {
    isLoading: false,
    groceryList: [],
    error: false
}
export default (state = initialState, action = {}) => {
    switch (action.type) {
        case Actions.GROCERY_LIST: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case Actions.GROCERY_LIST_SUCCESS: {

            return {
                ...state,
                isLoading: false,
                groceryList: action.data.response,
                error: false
            };
        }
        case Actions.GROCERY_LIST_FAILURE: {
            return {
                ...state,
                isLoading: false,
                error: action.error,
            };
        }
        default:
            return state;
    }
};
